import { BaseApiModel } from '@shared/models/base-api.model';
import { SessionModel } from '@shared/models/session.model';
import { EUserRole } from '@modules/iam/enum/user.role.enum';
import { EUserStatus } from '@modules/iam/enum/user.status.enum';
import { IDataUpdatedBy } from '@modules/iam/interfaces/user.updated-by.interface';

export type TUSerPosition = 'Master' | undefined;

export class UserModel extends BaseApiModel {
    createdBy: IDataUpdatedBy = {} as IDataUpdatedBy;
    email = '';
    firstname = '';
    lastname = '';
    oneTimePasswordExpiresAt?: number;
    role: EUserRole = EUserRole.None;
    status: EUserStatus = EUserStatus.new;
    companyId = '';

    session?: SessionModel = new SessionModel();
    avatar?: string;
    deletionPending?: boolean;
    userDeletionDate: number | null = null;
    staffNumber?: string;
    position: TUSerPosition;
    phone = '';
}
